export default __webpack_public_path__ + "static/media/cheese_thumb.534e6b0f.jpg";